import { defineComponent as E, mergeModels as B, useModel as S, useSlots as C, useTemplateRef as T, computed as $, onMounted as k, onBeforeUnmount as P, createElementBlock as R, openBlock as z, Fragment as L, createVNode as i, unref as b, withCtx as u, mergeProps as f, renderSlot as U, h as A } from "vue";
import D from "../MenuToggle/MenuToggle.vue2.js";
import K from "../Menu/Menu.vue2.js";
import N from "../Menu/MenuContent.vue2.js";
import V from "../../helpers/FloatingUi.vue2.js";
import j from "../../helpers/PassThrough.vue2.js";
import { useHtmlElementFromVNodes as q } from "../../use/index.js";
import { useOUIAProps as G } from "../../helpers/ouia.js";
const oe = /* @__PURE__ */ E({
  name: "PfDropdown",
  inheritAttrs: !1,
  __name: "Dropdown",
  props: /* @__PURE__ */ B({
    id: {},
    position: { default: "left" },
    appendTo: {},
    text: {},
    disabled: { type: Boolean },
    autoFocus: { type: Boolean, default: !0 },
    noCloseOnSelect: { type: Boolean },
    zIndex: { default: 9999 },
    placement: { default: "bottom" },
    splitButton: { type: [Boolean, String] },
    variant: {},
    scrollable: { type: Boolean },
    menuHeight: {},
    maxMenuHeight: {},
    shouldFocusFirstItemOnOpen: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ B(["select"], ["update:open"]),
  setup(m, { emit: y }) {
    let F = 0;
    const t = m, I = G({ id: t.ouiaId, safe: t.ouiaSafe }), l = S(m, "open"), w = y, d = C(), p = T("menuRef"), { element: s, findReference: x } = q(), H = $(() => t.id || `pf-dropdown-toggle-id-${F++}`), M = $(() => t.placement !== "top" && t.placement !== "bottom" ? t.placement : `${t.placement}-${t.position === "right" ? "end" : "start"}`);
    function O(e, n) {
      w("select", e, n), t.autoFocus && s.value instanceof HTMLElement && s.value.focus(), t.noCloseOnSelect || (l.value = !1);
    }
    function _() {
      const e = [], n = {
        id: H.value,
        disabled: t.disabled,
        expanded: l.value,
        "aria-haspopup": !!d.default,
        "onUpdate:expanded": (o) => l.value = o,
        onKeydown: c,
        ...I
      };
      if (d.toggle) {
        const o = d.toggle({});
        for (const a of o)
          a.props = f(a.props ?? {}, n);
        e.push(...o);
      } else {
        const o = A(D, f({
          splitButton: t.splitButton,
          variant: t.variant
        }, n), {
          default: () => t.text
        });
        e.push(o);
      }
      return e;
    }
    function c(e) {
      var n, o, a;
      if (l.value) {
        if (!["Escape", "Tab"].includes(e.key)) {
          (o = (n = p.value) == null ? void 0 : n.$.exposed) == null || o.handleKeyboard(e);
          return;
        }
        l.value = !1, s.value instanceof HTMLElement && ((a = s.value) == null || a.focus());
      }
    }
    const g = (e) => {
      var n, o, a, h, v;
      if (l.value)
        if ((n = s.value) != null && n.contains(e.target)) {
          if (t.shouldFocusFirstItemOnOpen) {
            const r = (a = (o = p.value) == null ? void 0 : o.$.exposed) == null ? void 0 : a.items;
            t.shouldFocusFirstItemOnOpen && (r != null && r.length) && r[0].focus();
          }
        } else (v = (h = p.value) == null ? void 0 : h.el) != null && v.contains(e.target) || (l.value = !1);
    };
    return k(() => {
      window.addEventListener("click", g);
    }), P(() => {
      window.removeEventListener("click", g);
    }), (e, n) => (z(), R(L, null, [
      i(j, { onChildren: b(x) }, {
        default: u(() => [
          i(_)
        ]),
        _: 1
      }, 8, ["onChildren"]),
      i(V, {
        "teleport-to": e.appendTo,
        flip: "",
        reference: b(s),
        placement: M.value,
        "z-index": e.zIndex,
        hidden: !l.value
      }, {
        default: u(() => [
          i(K, f({ ref: "menuRef" }, e.$attrs, {
            scrollable: e.maxMenuHeight !== void 0 || e.menuHeight !== void 0 || e.scrollable,
            onSelect: O,
            onKeydown: c
          }), {
            default: u(() => [
              i(N, {
                "menu-height": e.menuHeight,
                "max-menu-height": e.maxMenuHeight
              }, {
                default: u(() => [
                  U(e.$slots, "default")
                ]),
                _: 3
              }, 8, ["menu-height", "max-menu-height"])
            ]),
            _: 3
          }, 16, ["scrollable"])
        ]),
        _: 3
      }, 8, ["teleport-to", "reference", "placement", "z-index", "hidden"])
    ], 64));
  }
});
export {
  oe as default
};
